import { Grid, Paper, Box, Typography } from "@mui/material";
import NumberFormat from "react-number-format";
import colors from "../../../config/colors";
import CustomLabel from "../common/customLabel";
import { format } from "date-fns";

const CardMontoDisponible = ({
  idTipoBalance = 0,
  title,
  styleTitle,
  minHeightBarra,
  maximoBarra,
  actualBarra,
  ButtonComponent,
  elevation = 0,
  styleLabelMontoDisponible,
  fechaRenovacion,
  mostrarPlan = false
}) => {

  const regimenList = ['CONTRIBUTIVO', 'SeNaSa LARIMAR', 'SUBSIDIADO'];
  const porcentajeActual = (actualBarra / maximoBarra) * 100;

  const cardStyles = {
    container: {
      borderRadius: "16px",
      background: `linear-gradient(135deg, ${colors.primary} 0%, #45a049 100%)`,
      color: "white",
      padding: "24px",
      margin: "8px",
      boxShadow: "0 4px 20px rgba(76, 175, 80, 0.3)",
      border: "none",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 8px 30px rgba(76, 175, 80, 0.4)",
      },
    },
    titleContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
    },
    title: {
      fontSize: "16px",
      fontWeight: "600",
      color: "white",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    status: {
      fontSize: "12px",
      fontWeight: "500",
      color: "rgba(255, 255, 255, 0.9)",
      textTransform: "uppercase",
      letterSpacing: "0.3px",
    },
    amountContainer: {
      marginBottom: "16px",
    },
    currentAmount: {
      fontSize: "32px",
      fontWeight: "700",
      color: "white",
      lineHeight: "1.2",
      marginBottom: "4px",
    },
    maxAmount: {
      fontSize: "16px",
      fontWeight: "400",
      color: "rgba(255, 255, 255, 0.8)",
    },
    progressContainer: {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      borderRadius: "20px",
      height: "8px",
      marginBottom: "20px",
      overflow: "hidden",
    },
    progressBar: {
      height: "100%",
      backgroundColor: "white",
      borderRadius: "20px",
      transition: "width 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    footer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "12px",
    },
    dateContainer: {
      textAlign: "left",
    },
    dateLabel: {
      fontSize: "12px",
      fontWeight: "500",
      color: "rgba(255, 255, 255, 0.7)",
      marginBottom: "2px",
      textTransform: "uppercase",
      letterSpacing: "0.3px",
    },
    dateValue: {
      fontSize: "14px",
      fontWeight: "600",
      color: "white",
    },
    buttonContainer: {
      "& button": {
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        borderRadius: "8px",
        color: "white",
        fontSize: "12px",
        fontWeight: "600",
        padding: "8px 16px",
        textTransform: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.25)",
          transform: "translateY(-1px)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        },
      },
    },
  };

  return (
    <Paper
      elevation={elevation}
      sx={cardStyles.container}
      style={{
        ...cardStyles.container,
        ...styleTitle,
      }}
    >
      {/* Header con título y estado */}
      <Box sx={cardStyles.titleContainer}>
        <Box>
           { mostrarPlan ? <Typography sx={{...cardStyles.title, textTransform: 'capitalize', fontWeight: 'thin'}}>plan</Typography> : null}
           { mostrarPlan ? <Typography sx={cardStyles.title}>{regimenList.includes(title) ? 'Básico' : title}</Typography> : <Typography sx={cardStyles.title}>{title}</Typography>} 
        </Box>
       
        <Typography sx={cardStyles.status}>Posee Servicio</Typography>
      </Box>

      {/* Sección de montos */}
      <Box sx={cardStyles.amountContainer}>
        <Typography sx={cardStyles.currentAmount}>
          <NumberFormat
            value={actualBarra}
            thousandSeparator={true}
            displayType={"text"}
            renderText={(value) => `RD$${value}`}
          />
        </Typography>
        <Typography sx={cardStyles.maxAmount}>
          de{" "}
          <NumberFormat
            value={maximoBarra}
            thousandSeparator={true}
            displayType={"text"}
            renderText={(value) => `RD$${value}`}
          />
        </Typography>
      </Box>

      {/* Barra de progreso */}
      <Box sx={cardStyles.progressContainer}>
        <Box
          sx={{
            ...cardStyles.progressBar,
            width: `${Math.min(porcentajeActual, 100)}%`,
          }}
        />
      </Box>

      {/* Footer con fecha y botón */}
      <Box sx={cardStyles.footer}>
        {fechaRenovacion && (
          <Box sx={cardStyles.dateContainer}>
            <Typography sx={cardStyles.dateLabel}>
              Fecha de renovación
            </Typography>
            <Typography sx={cardStyles.dateValue}>
              {format(new Date(fechaRenovacion), "dd-MM-yyyy")}
            </Typography>
          </Box>
        )}

        {idTipoBalance !== 0 && ButtonComponent && (
          <Box sx={cardStyles.buttonContainer}>{ButtonComponent}</Box>
        )}
      </Box>
    </Paper>
  );
};

export default CardMontoDisponible;